import { cn } from "@/lib/utils";
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

export const MetricTile = ({ 
  label, 
  value, 
  trend, // 'up' | 'down' | 'neutral'
  trendValue,
  className 
}) => {
  const TrendIcon = trend === 'up' ? TrendingUp : trend === 'down' ? TrendingDown : Minus;
  const trendColor = trend === 'up' ? 'text-cool-mint' : trend === 'down' ? 'text-signal-red' : 'text-soft-silver';
  
  return (
    <div 
      className={cn(
        "bg-graphite rounded-xl border border-white/[0.06] p-4 sm:p-6",
        className
      )}
      data-testid="metric-tile"
    >
      <p className="text-soft-silver text-sm mb-2">{label}</p>
      <div className="flex items-end justify-between gap-2">
        <span className="text-3xl sm:text-4xl font-semibold text-cloud-white font-mono tracking-tight">
          {value}
        </span>
        {trend && (
          <div className={cn("flex items-center gap-1 text-sm", trendColor)}>
            <TrendIcon className="w-4 h-4" />
            {trendValue && <span className="font-mono">{trendValue}</span>}
          </div>
        )}
      </div>
    </div>
  );
};

export const StatStrip = ({ stats, className }) => {
  return (
    <div 
      className={cn(
        "grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4",
        className
      )}
      data-testid="stat-strip"
    >
      {stats.map((stat, index) => (
        <MetricTile key={index} {...stat} />
      ))}
    </div>
  );
};

export default StatStrip;
